import {gaConfig} from '@stencil/hotels-config';
import {pushga} from 'ga-utils/src/ga-utils';

const {detailsPageClickEventCategoryName} = gaConfig;

const detailsPageClickGaPush = ({
  event,
  eventCategory = detailsPageClickEventCategoryName,
  eventAction,
  eventLabel,
  ...customDimensions
}: {
  event?: string;
  eventCategory?: string;
  eventAction?: string;
  eventLabel?: any;
  customDimsions?: Object;
}) => {
  pushga({
    event,
    eventCategory,
    eventAction,
    eventLabel,
    ...customDimensions,
  });
};

export default detailsPageClickGaPush;
